/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Searchtitle1Inputs */

const zh_learn_searchtitle1 = /** @type {(inputs: Learn_Searchtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索 (⌘K)`)
};

const en_learn_searchtitle1 = /** @type {(inputs: Learn_Searchtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search (⌘K)`)
};

const es_learn_searchtitle1 = /** @type {(inputs: Learn_Searchtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar (⌘K)`)
};

/**
* | output |
* | --- |
* | "Search (⌘K)" |
*
* @param {Learn_Searchtitle1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_searchtitle1 = /** @type {((inputs?: Learn_Searchtitle1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Searchtitle1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_searchtitle1(inputs)
	if (locale === "en") return en_learn_searchtitle1(inputs)
	return es_learn_searchtitle1(inputs)
});
export { learn_searchtitle1 as "learn_searchTitle" }